import React, { useEffect, useState } from 'react'
import _orderBy from 'lodash/orderBy'
import _sumBy from 'lodash/sumBy'
import _keyBy from 'lodash/keyBy'
import { each } from 'awaity/esm'
import { Select, Layout, Row, Form, Col, Button, Table, Progress, Modal, Switch } from 'antd'
import { clientRace, clientResults } from './client'
import { queryEvents, queryTicketItems, queryCountRunner, queryCountEcer, queryEcer } from './query'
import { mutationEcer } from './mutation'
import _get from 'lodash/get'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
}

const columns = [{
  title: 'Bib',
  dataIndex: 'number',
}, {
  title: 'Name',
  dataIndex: 'participant.profile.firstName',
}, {
  title: 'Lastname',
  dataIndex: 'participant.profile.lastName',
}]

function useFetch(client) {
  const [data, setDate] = useState([])
  const [loading, setLoading] = useState(true)

  async function fetchUrl(query, variable = {}) {
    try {
      const results = await client.request(query, variable)
      setDate(results)
      setLoading(false)
      return results
    } catch (err) {
      console.error(err)
    }
  }

  return [fetchUrl, data, loading]
}

function GenerateEcer() {
  // const { loading, error, data } = useQuery(queryEvent)
  const [fetchEvent, { events }, loadingEvent] = useFetch(clientRace)
  const [fetchTickets] = useFetch(clientRace)
  const [fetchParticipantCount, { participantCount }] = useFetch(clientRace)
  const [fetchEcerCount, { timeCount }] = useFetch(clientResults)
  const [fetchEcer, { times }] = useFetch(clientResults)
  const [mutateEcer/* , { generateEcer }  */] = useFetch(clientResults)
  const [eventId, setEventId] = useState('')
  const [slug, setSlug] = useState('')
  const [nonEcer, setNonEcer] = useState([])
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [generating, setGenerating] = useState(false)
  const [progressGenerating, setProgressGenerating] = useState(0)
  const [listSlug, setListSlug] = useState([])
  const [isMultiRace, setIsMultiRace] = useState(false)
  // const [countRunner, setCountRunner] = useState[0]

  const checkStatus = status => status === 'paid'
  const checkRunFinish = (run, target) => run >= target
  const checkDistance = distance => distance !== 0

  const handleInvokeData = async () => {
    setLoading(true)
    setProgress(0)
    const limit = 1000
    const nCount = Math.ceil(participantCount / limit)
    let skip = 0
    const renewTimes = _keyBy(times, time => time.bibNumber)

    const value = []
    await each([...Array(nCount)], async (e, i) => {
      skip = i * limit
      const tickets = await fetchTickets(queryTicketItems, {
        eventId,
        limit,
        skip,
      })
      let results
      results = tickets.ticketItems.filter((ticket) => {
        const { number, /* participant: { registration: { status } }, */ ticketType: { race: { distance } } } = ticket
        const status = _get(ticket, 'participant.registration.status')
        const summary = _sumBy(ticket.runs, o => o.distance)

        return (checkStatus(status) && checkRunFinish(summary, distance) && checkDistance(distance) && !renewTimes[number])
      })
      setProgress(((i + 1) * 100) / nCount)
      if (listSlug.length !== 0) {
        results = results.filter(e => e.ticketType.race.slug === slug)
      }
      console.log(results)
      value.push(results)
    })

    setNonEcer(value.reduce((old, val) => [...old, ...val], []))
    setLoading(false)
  }

  const handleGenerate = async () => {
    setGenerating(true)
    await each(nonEcer, async (runner, index) => {
      const { number, ticketType: { race: { distance } }, participant: { profile: { firstName, lastName } } } = runner
      const summary = _sumBy(runner.runs, o => o.distance)
      const record = {
        bib: number.toString(),
        race: isMultiRace ? distance.toString() : 'normal',
        name: `${firstName} ${lastName}`,
        gunTime: summary.toString(),
      }
      await mutateEcer(mutationEcer, { slug, record })
      console.log('generated', record)
      setProgressGenerating(((index + 1) * 100) / nonEcer.length)
    })
    Modal.success({
      title: 'Generate Ecer success !',
      content: 'Generate Tolal: '+nonEcer.length,
      onOk: () => window.location.reload(),
    })
    setGenerating(false)
  }

  useEffect(() => {
    fetchEvent(queryEvents)
  }, [])

  useEffect(() => {
    if (eventId && slug) {
      fetchParticipantCount(queryCountRunner, {
        eventId,
      })
    }
  }, [eventId, slug])

  useEffect(() => {
    if (slug) {
      fetchEcerCount(queryCountEcer, {
        slug,
      })
    }
  }, [slug])

  useEffect(() => {
    if (slug) {
      fetchEcer(queryEcer, {
        slug,
        limit: 20000, // timeCount,
      })
    }
  }, [slug])

  if (loadingEvent) return <div>loading event ...</div>

  // console.log('data', data.events)
  const eventsData = _orderBy(events, 'settings.virtualRun.period.start', 'desc')
  // console.log('ticketItems', ticketItems)
  // console.log('participantCount', participantCount)
  // slug && console.log('slug', slug)
  // listSlug && console.log('listSlug', listSlug)
  console.log('timeCount', timeCount)
  // console.log('times', times)
  return (
    <Layout>
      <Layout.Content style={{ backgroundColor: '#fff' }}>
        <h1>Generate Ecer.</h1>
        <Row>
          <Col md={{ span: 12, offset: 4 }}>
            <Form {...formItemLayout}>
              <Form.Item label="Event">
                <Select
                  showSearch
                  onChange={(e) => {
                    const event = events.find(ev => ev._id === e)
                    const { races } = event
                    const listSlug = races.filter(race => race.slug !== null && race.slug !== '')
                    if (listSlug.length !== 0) {
                      setListSlug(listSlug)
                      setSlug('')
                    } else {
                      setListSlug([])
                      setSlug(event.slug)
                    }
                    setEventId(e)
                  }}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {eventsData.map(ev => (
                    <Select.Option
                      key={ev._id}
                      value={ev._id}
                    >{ev.name.en}
                    </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Form>
            {listSlug.length !== 0 ?
              <Form {...formItemLayout}>
                <Form.Item label="Slug">
                  <Select
                    onChange={(e) => {
                      setSlug(e)
                    }}
                  >
                    {
                      listSlug.map(({ slug }, index) => (
                        <Select.Option key={slug} value={slug}>{slug}</Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </Form>
            : null}
            {participantCount &&
              <div>
                <Form.Item
                  {...formItemLayout}
                  label="Multiple Race"
                >
                  <Switch onChange={e => setIsMultiRace(e)} />
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                  <Button type="primary" loading={!times || loading} disabled={!times} onClick={() => handleInvokeData()}>Invoke Data</Button>
                  {loading && <Progress percent={progress} status="active" showInfo={false} />}
                </Form.Item>
              </div>
            }
            {nonEcer.length !== 0 &&
            <Form.Item {...tailFormItemLayout}>
              <Table rowKey={e => e.number} columns={columns} dataSource={nonEcer} scroll={{ y: 240 }} />
              <Button type="primary" onClick={() => handleGenerate()}>{`Generate ${nonEcer.length}`}</Button>
              {generating && <Progress percent={progressGenerating} status="active" showInfo={false} />}
            </Form.Item>}
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  )
}

export default GenerateEcer



// WEBPACK FOOTER //
// ./src/CreateEcer/GenerateEcer.js